import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useSelector } from "react-redux";
import { store } from "../../store/store";

const baseUrl = process.env.REACT_APP_base_URL;

const createGroup = createApi({
    reducerPath: 'createGroup',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        createGroup: builder.mutation({
            query: ({ userId ,groupName,solutionProviderId,businessUserId , solutionId , boardId}) => ({
                url:`chat/group`,
                method: 'POST',
                body: { 
                    userId:userId,
                    name: groupName, 
                    solution_provider_id:solutionProviderId, 
                    business_user_id: businessUserId,
                    solution_id: solutionId,
                    boardId: boardId
             },
            }),
            transformResponse: (response) => {
                return response;
            },
        }),
    }),
});

export const { useCreateGroupMutation } = createGroup;
export default createGroup;
